import { Flag02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { cx } from "shared/utils/classnames";
import type { ConversationFlagClear } from "../types";
import { flagClearParts } from "../utils/flagClears";

export const FlagClearLine = ({
  clear,
  compact
}: {
  clear: ConversationFlagClear;
  compact: boolean;
}) => {
  const { who, label, when } = flagClearParts(clear);

  return (
    <div
      className={cx(
        "flex items-center justify-center gap-2 font-medium text-content-300",
        compact ? "mt-2 text-sm" : "mt-6 text-xs"
      )}
    >
      <HugeiconsIcon icon={Flag02Icon} size={16} className="shrink-0" />
      <span>
        <span className="font-bold text-content-1000">{who}</span> cleared the
        flag: {label}
      </span>
      <div className="size-1 shrink-0 rounded-full bg-content-200" />
      <span className="shrink-0">{when}</span>
    </div>
  );
};
